module.exports = {
  add_more: 'Add more',
  provideFullAddress: 'Gelieve je volledige adres in te vullen',
  dropdownBoth: 'Gelieve alle velden in te vullen',
  dropdownDay: 'Choose your preferred date',
  dropdownTime: 'Choose your preferred time',
  pictureDescription: 'Add a caption (optional)',
  changeEmail: 'Yes, change it',
  dontChangeEmail: 'No, keep it',
  yes: 'Yes',
  no: 'No',
  'next-step': 'Volgende',
  'next-step-wizard': 'Volgende',
  step: 'Step',
  off: 'Off',
  'first-step-wizard': 'Ja, aan de slag',
  'last-step': 'Ontvang offertes',
  'go-back': 'Vorige',
  'go-back-wizard': 'Vorige stap',
  understood: 'Ik begrijp het!',
  'company-placeholder': 'Bedrijf B.V.',
  'company-autocomplete-label': '',
  'company-label': 'Bedrijf',
  'address-placeholder': 'Straatnaam & nummer',
  address_no_number_placeholder: 'Voorbeeldstraat',
  'address-label': 'Adres',
  'address-street-number-label': 'Huisnr',
  'address-street-number-placeholder': '1A',
  'address-no-street-number-label': 'Het adres heeft geen huisnummer',
  'address-not-found': 'Het adres kan niet gevonden worden',
  'address-no-match': 'Geen resultaten',
  'address-choose-from': 'Choose among several addresses',
  'address-invalid': 'Het adres is ongeldig',
  'address-missing': 'Het adres ontbreekt',
  'address-missing-street-number': 'Het huisnummer ontbreekt',
  address_alert: 'Heb je het juiste adres ingegeven?',
  address_missing_city: 'The city is missing',
  'phone-invalid-length': '',
  'zip-error': 'Please add your Eircode',
  'zip-label': 'Postcode',
  'zip-does-not-exist': "The Eircode doesn't exist",
  'zip-warning': 'Are you sure you provided the correct Eircode?',
  zip_placeholder: '1234',
  'name-label': 'Naam',
  'date-format': 'DD/MM/YY',
  'date-label': 'Date (6 digits)',
  'birthdate-label': 'Date of birth (6 digits)',
  'national-identity-label': 'Your national identification number',
  'national-identity-placeholder': '',
  'national-identity-invalid': 'The national identification number is invalid',
  'national-identity-identical':
    "The co-borrower's national identification number can't be identical to that of the prinicipal applicant's",
  'bank-account-label': 'Your bank account number',
  'measuring-id-invalid': 'The Meter Point Reference Number is invalid',
  'bank-account-placeholder': '8 digits',
  'bank-account-invalid': 'The bank account number is invalid',
  'organization-identity-label': 'Btw-nummer',
  'organization-identity-placeholder': 'BE 0123.456.789',
  'organization-identity-invalid': 'Het Btw-nummer is ongeldig',
  'date-invalid': 'The date is invalid',
  'name-placeholder': 'Voornaam Achternaam',
  'name-invalid': 'De naam is ongeldig',
  'email-alert-message': 'Did you write the correct email?',
  'email-label': 'E-mail',
  'email-placeholder': 'naam@domein.com',
  'email-does-not-exist': 'Het e-mailadres bestaat niet',
  'email-invalid': 'Het e-mailadres is ongeldig',
  email_did_you_mean: 'Did you mean',
  'fetching-information': 'Fetching information',
  'comment-label': 'Additional information',
  'comment-placeholder': 'Optional, e.g. state specific needs or other relevant info here. ',
  'phone-alert-message': 'Did you write the correct phone number?',
  'phone-label': 'Telefoonnummer',
  'phone-invalid': 'Het telefoonnummer is ongeldig',
  'phone-must-begin-with-+': 'Phone number must begin with + ',
  'phone-foreign': 'Foreign phone number',
  'phone-placeholder': '0470 12 34 56',
  'phone-foreign-placeholder-prefix': '353',
  'error-x-numbers': 'Moet --x-- cijfers bevatten',
  'error-x-letters': 'Must contain --x-- letters',
  'error-min-rooms': 'You must choose at least one room',
  'error-min-x-letters': 'Vul minimaal --x-- letters in',
  'error-min-x-numbers': 'Must contain at least --x-- digits',
  'error-max-x-numbers': 'Must contain maximum --x-- digits',
  'error-inbetween-numbers': 'Must contain --x------y digits',
  'error-must-consist-of-x-letters': 'Must contain at least --x-- letters',
  'error-mandatory': 'Verplicht veld',
  'error-choose': 'Maak een keuze',
  'error-min-age': 'Unfortunately, offers are only available to customers older than --x-- years',
  'error-must-accept': 'Verplicht te aanvaarden',
  'error-only-digits': 'Alleen cijfers',
  privacy:
    '<strong>Je privacy is beschermd:</strong> alle formuliergegevens worden versleuteld via een beveiligde verbinding en we gaan volgens de GDPR zorgvuldig met je gegevens om.',
  'privacy-policy':
    '<h4>Privacy policy</h4><p><p>Privacy is essential to us at --x--. As a user, you can be confident that we will not use the information you provide for anything other than what you have given consent to and that we will store it securely.</p> <p>The data you hand in is the minimum suppliers require to be able to provide you with specific offers based on your needs. It will not be used for anything other than to provide you with offers within a reasonable time, based on your choices and preferences for communication and the administrative work related to this.</p><p>Your data is processed by the Norwegian IT company Nettbureau AS, which owns and operates --x--, and by the relevant suppliers.</p><p>Personal information about you shall only be processed for lawful purposes and will be deleted or anonymised when we no longer have grounds to process them.</p><p>Nettbureau must ensure that personal data about you is satisfactorily protected.</p><p>Nettbureau ensures communication with users using encryption.</p><p>Read more in our <a href="--y--" target="__blank">privacy policy</a>.</p>',
  close: 'Close',
  error_radio_button: 'Gelieve een veld te kiezen',
  invalid_day: 'The date is invalid',
  invalid_day_in_month: "This date doesn't exist this month",
  invalid_month: 'The month is invalid',
  invalid_year: 'The year is invalid',
  invalid_country: 'The country is invalid',
  label_birthdate: 'Date of birth',
  label_date: 'Date',
  label_day: 'Day',
  label_month: 'Month',
  label_year: 'Year',
  locale: '',
  new_locale: '',
  missing_date: 'The date is missing',
  missing_month: 'The month is missing',
  missing_year: 'The year is missing',
  'datepicker-button': 'Choose date',
  email_wrong_user_account: 'Are you sure the email user account is correct?',
  email_wrong_email_address: 'Are you sure you have entered a valid email address?',
  not_valid_municipality: "The municipiality isn't valid",
  not_valid_state: "The state isn't valid",
  'invalid-file-size': 'The maximum file size is',
  'invalid-file-type': 'Invalid file type, valid file types are',
  'drop-files-first': 'Drop your files here or',
  'drop-files-last': 'click here to capture an image',
  'vehicle-label': 'Registration number',
  'vehicle-invalid': "The registration number isn't correct",
  'leazard-error-boundary-headline': 'Sorry, er ging iets fout',
  'leazard-error-boundary-description':
    'Druk op onderstaande knop om opnieuw te proberen. Indien het probleem zich blijft voordoen: ',
  'leazard-error-boundary-contact-customer-service': 'Contacteer onze klantendienst',
  'leazard-error-boundary-email-subject': 'Form error',
  'leazard-error-boundary-button-text': 'Please try again',
  'sms-verification-label': 'Verify your phone number',
  'sms-verification-tinyLabel':
    'We’ve sent you a text message from "+47 59 44 45 00" with a verification code to confirm that --xx-- belongs to you. This ensures we can process your request quickly and correctly.',
  'sms-verification-error-message': 'Wrong code',
  'sms-verification-code-not-received-first': "Haven't received a code? ",
  'sms-verification-code-not-received-link': 'Click here',
  'sms-verification-code-not-received-last': ' to send it again.',
  'sms-verification-code-is-sent-again': "We've resent the code.",
  'sms-verification-code-retry-error': 'Please wait 30 seconds before trying again.',
  'eircode-invalid': 'This eircode is invalid',
  'leazard-two-factor-header': 'Nearly there',
  'leazard-two-factor-help-text':
    "We’ve sent you a text message with a verification code to confirm that this number belongs to you. You won't receive any more messages from +47 59 44 45 00.",
  'leazard-two-factor-submit': 'Complete',
  'leazard-two-factor-label': 'Write in the code',
  'leazard-loading-text': 'Je gegevens worden verwerkt',
  'accept-terms-of-use':
    'I accept the --x-- and confirm that the personal information is accurate.',
  'recaptcha-disclaimer': 'Deze site wordt beschermd door reCAPTCHA.',
};
